import { Switch } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import { hot } from 'react-hot-loader/root';
import * as moment from 'moment';
import Button from 'UI/button';
import LabelInput from 'UI/labelInput';

class DailyReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      classes,
      dailyReport,
      onDailyReportChange,
      onDailyReportSubmit,
    } = this.props;
    const { entries } = dailyReport.data;
    return (
      <div className={classes.container}>
        <div
          className={classes.header}
        >
          EOD Report for {moment().utcOffset('+0530').format('DD MMM YYYY')}
        </div>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          padding: '20px',
        }}
        >
          {
            entries.map((entry) => {
              return (
                <div style={{ flex: '0 0 calc(50% - 10px)' }} key={entry.uuid}>
                  {
                    entry.type === 'number' ? (
                      <LabelInput
                        type="number"
                        label={entry.label}
                        value={entry.value}
                        onChange={(val) => {
                          onDailyReportChange(entry.uuid, val);
                        }}
                      />
                    ) : null
                  }
                  {
                    entry.type === 'boolean' ? (
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div>
                          {entry.label}
                        </div>
                        <div>
                          <Switch
                            checked={Boolean(entry.value)}
                            label={entry.label}
                            color="primary"
                            onChange={(e) => {
                              onDailyReportChange(entry.uuid, e.target.checked);
                            }}
                          />
                          {entry.value ? 'Yes' : 'No'}
                        </div>
                      </div>
                    ) : null
                  }
                </div>
              );
            })
          }
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <Button
              className={classes.okayButton}
              onClick={onDailyReportSubmit}
            >
              {dailyReport.data.status === 'UPDATED' ? 'Update' : 'Submit'}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {
    flex: 1,
    flexDirection: 'column',
    width: 890,
  },
  body: {
    padding: 40,
    flex: 1,
    flexDirection: 'column',
  },
  input: {
    height: 64,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    color: theme.colors.white,
    fontSize: '18px',
    fontWeight: 'bold',
    padding: '10px 20px',
    justifyContent: 'center',
    backgroundColor: theme.colors.primary,
    borderBottom: '0.5px solid white',
  },
  customQuoteButton: {
    color: theme.colors.white,
    backgroundColor: 'transparent',
    border: `1px solid ${theme.colors.white}`,
    fontWeight: 'bold',
    height: '32px',
    borderRadius: '16px',
    margin: '10px 10px',
  },
});

DailyReportModal.propTypes = {
  classes: PropTypes.object,
  dailyReport: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onDailyReportSubmit: PropTypes.func.isRequired,
  onDailyReportChange: PropTypes.func.isRequired,
};

export default hot(withStyles(styles)(DailyReportModal));
